import { theme } from "@findemdev/maui";
import { CompanyListsTableColumnKeysType, CompanyListTableColumnValues } from "../util/common";

interface IHeaderProps {
  col: CompanyListsTableColumnKeysType;
};

const Header = ({
  col,
}: IHeaderProps) => {

  return <div
    style={{
      padding: "8px"
    }}
  >
    <div style={{
      fontWeight: "400",
      fontSize: "14px",
      color: theme.colors['grey-600'],
      lineHeight: "19.6px"

    }}>{CompanyListTableColumnValues[col].title}</div>
  </div>
};

export default Header;